import styled from "styled-components";
import { DefaultParagraphMediumFactory, DefaultTitleSmallFactory } from "../core/Typograph/Typograph.Style";

export const CardActivateInsuranceContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: "32px",

    [theme.breakpoint.lg()]: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "32px",
        alignSelf: "stretch",
        paddingTop: "40px",
    }
}))

export const CardActivateInsuranceContentGroup = styled.div(() => ({
    display: "flex",
    alignItems: "center",
    width: "100%",
    marginBottom: "32px",
    position: "relative",
    overflow: "hidden",
    gap: "32px",
    flexWrap: "wrap",
}))

export const CardActivateInsuranceContent = styled.div(({isActive, theme}) => ({
    display: "flex",
    padding: "32px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "40px",
    flex: "1 0 0",
    border: "1px solid #D1DBE3",
    width: "336px",
    justifyContent: "center",
    position: "relative",
    borderRadius: "8px",
    backgroundColor: `${isActive ? theme.color.brandPrimary.light : theme.color.neutral['08']}`,
    color: `${isActive ? theme.color.neutral['08'] : theme.color.brandPrimary.light}`,
    h3:{
        color: `${isActive ? '#fff' : theme.color.neutral['02']}`,
    },
    [theme.breakpoint.lg()]: {
        width: "592px",
    }
}))

export const CardActivateInsuranceTitle = styled.h3(({ theme }) => ({
    ...DefaultTitleSmallFactory({ theme }),
    textDecoration: "underline",
    alignSelf: "stretch",
}))

export const CardActivateInsuranceDescription = styled.a(({ theme }) => ({
    ...DefaultParagraphMediumFactory({ theme }),
}))

export const CardActivateInsuranceButtons = styled.div(({ theme }) => ({
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "stretch",
    textAlign: "center",
    [theme.breakpoint.lg()]: {
        justifyContent: "space-between",
        display: "flex",
    }
}))

export const CardActivateInsuranceIconWithTitle = styled.div(() => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    gap: "8px",
    alignSelf: "stretch",
}))


